import { render, staticRenderFns } from "./underageTerm.vue?vue&type=template&id=318fc3f2"
import script from "./underageTerm.vue?vue&type=script&lang=js"
export * from "./underageTerm.vue?vue&type=script&lang=js"
import style0 from "./underageTerm.vue?vue&type=style&index=0&id=318fc3f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports